<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 mx-auto self-center">
      <vx-card>
        <div class="vx-card__title">
          <h2 class="text-center">We are launching soon</h2>
        </div>
        <img
          src="@/assets/images/pages/rocket.png"
          alt="coming-soon"
          class="mx-auto mb-2"
          width="150"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  components: {
  }
};
</script>